// VARIABLES
const urls = {
  // bar: 'http://localhost:4321/prepare',
  // kitchen: 'http://localhost:4321/prepare',
  bar: 'https://madis-bar.ordo.party/prepare',
  kitchen: 'https://madis-kitchen.ordo.party/prepare',
};
const request = (url, body) => new Request(url, {
  method: 'POST',
  headers: new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    printkey: '27253e03ae3afdbbc42e07446242a7b727ecd1371e59efab9b99b6677d910cd9',
  }),
  body: JSON.stringify(body),
});
// CREATE PRINT DETAILS
export const createPrintDetails = (items, user, categories, tableNumber) => {
  try {
    const getItemCategory = itemID => {
      let itemCategory = '';
      Object.keys(categories.byId).forEach(categoryID => {
        if (categories.byId[categoryID].itemIds.includes(itemID)) {
          itemCategory = categories.byId[categoryID].name;
        }
      });
      return itemCategory;
    };
    const kitchenCategories = [
      'Breakfast and Brunch',
      'Starters',
      'M 12/12 Hotsauces',
      'Nachos',
      'Poke, Salads and Bowls',
      'Taco Tuesday!',
      'Desserts',
      'Sides & Kids Menu',
      'Wing & Pizza Wednesday!',
    ];
    const barItems = [];
    const kitchenItems = [];
    items.forEach(item => {
      const category = getItemCategory(item.id);
      const itemData = {
        printed: [],
        customer: `${user.firstName} ${user.lastName || ''}`.trim(),
        name: item.name,
        category,
        addOns: item.optionValues
          .filter(({ price }) => price > 0)
          .map(({ name, quantity }) => ({ name, quantity })),
        options: item.optionValues
          .filter(({ price }) => price === 0)
          .map(({ name, quantity }) => ({ name, quantity })),
        size: item.size,
        price: item.price,
        note: item.specialInstructions || '',
      };
      if (kitchenCategories.includes(category.replaceAll(/'/g, '')) && item.name !== 'Boozy Vietnamese Coffee') {
        kitchenItems.push(itemData);
      } else {
        barItems.push(itemData);
      }
    });
    const printDetails = {
      table: tableNumber,
      barItems,
      kitchenItems,
    };
    return printDetails;
  } catch (error) {
    return null;
  }
};
// PREPARE TO PRINT
export const prepareToPrint = data => {
  try {
    const {
      id, table, barItems, kitchenItems,
    } = data;
    if (barItems.length) {
      fetch(request(urls.bar, { id, table, items: barItems }));
    }
    if (kitchenItems.length) {
      fetch(request(urls.kitchen, { id, table, items: kitchenItems }));
    }
    return true;
  } catch (error) {
    return false;
  }
};
